import { lazy, Suspense, type ReactNode } from "react";
import type { RouteObject } from "react-router-dom";
import Layout from "../components/feature/Layout";

function Lazy({ children }: { children: ReactNode }) {
  return (
    <Suspense
      fallback={
        <div className="min-h-screen flex items-center justify-center bg-black">
          <div className="flex flex-col items-center gap-4">
            <div className="w-10 h-10 border-2 border-gold/30 border-t-gold rounded-full animate-spin" />
            <span className="text-white/30 text-sm font-montserrat">Yükleniyor...</span>
          </div>
        </div>
      }
    >
      {children}
    </Suspense>
  );
}

const Home = lazy(() => import("../pages/home/page"));
const About = lazy(() => import("../pages/about/page"));
const Services = lazy(() => import("../pages/services/page"));
const ServiceDetail = lazy(() => import("../pages/services/detail"));
const Exchange = lazy(() => import("../pages/exchange/page"));
const Calculator = lazy(() => import("../pages/calculator/page"));
const Blog = lazy(() => import("../pages/blog/page"));
const BlogDetail = lazy(() => import("../pages/blog/detail"));
const KVKK = lazy(() => import("../pages/legal/kvkk"));
const CookiePolicy = lazy(() => import("../pages/legal/cookie"));
const Gallery = lazy(() => import("../pages/gallery/page"));
const NotFound = lazy(() => import("../pages/NotFound"));

const routes: RouteObject[] = [
  {
    element: <Layout />,
    children: [
      { path: "/", element: <Lazy><Home /></Lazy> },
      { path: "/hakkimizda", element: <Lazy><About /></Lazy> },
      { path: "/hizmetler", element: <Lazy><Services /></Lazy> },
      { path: "/hizmetler/:slug", element: <Lazy><ServiceDetail /></Lazy> },
      { path: "/doviz-kurlari", element: <Lazy><Exchange /></Lazy> },
      { path: "/hesaplama", element: <Lazy><Calculator /></Lazy> },
      { path: "/galeri", element: <Lazy><Gallery /></Lazy> },
      { path: "/blog", element: <Lazy><Blog /></Lazy> },
      { path: "/blog/:slug", element: <Lazy><BlogDetail /></Lazy> },
      { path: "/kvkk", element: <Lazy><KVKK /></Lazy> },
      { path: "/cerez-politikasi", element: <Lazy><CookiePolicy /></Lazy> },
      { path: "*", element: <Lazy><NotFound /></Lazy> },
    ],
  },
];

export default routes;
